(function () {
    'use strict';

    var serviceId = 'restoreUrlService';

    angular.module('app.security')
        .factory(serviceId, ['localStorageService', '$q', '$window', '$state', restoreUrlService]);

    function restoreUrlService(localStorageService, $q, $window, $state) {
        var service = {
            returnTo: returnTo,
            getLastState: getLastState,
            saveLastState: saveLastState,
            removeLastState: removeLastState
        };
        var fromState, fromParams;
        return service;

        function getLastState() {
            var deferred = $q.defer();

            fromState = localStorageService.get('fromState');
            fromParams = localStorageService.get('fromParams');
            deferred.resolve({
                lastState: fromState,
                lastParams: fromParams
            });

            return deferred.promise;

        }

        function returnTo(force_restart) {
            console.log("start getting last state");
            service.getLastState().then(function (res) {
                console.log("finish getting last state", res);
                var storedLang = $window.lang || 'en';
                console.log("stored lang", storedLang);
                //TODO: [EB-271] Externalauth (Google) redirection bazı durumlarda sayfasına 404 sayfasına gidiyor.
                force_restart = force_restart || !res.lastState || res.lastState === "" || res.lastState === "externalauth" || res.lastState === "confirmoop" || res.lastState === "renew";
                console.log("stored lang", force_restart);
                console.log("start getting ivaluateProperty");
                if (window.localStorage.getItem('ivaluateProperty')) {
                    console.log("finish getting ivaluateProperty");
                    window.localStorage.removeItem('ivaluateProperty');
                    console.log("topKey", window.topKey);
                    if (!force_restart)
                        $state.go('resident-valuation.step4', { langcode: storedLang, calculate: true, top: window.topKey });
                    else
                        $window.location.href = $state.href('resident-valuation.step4', { langcode: storedLang, calculate: true, top: window.topKey });
                }
                else if (window.localStorage.getItem('ivaluateLand')) {
                    window.localStorage.removeItem('ivaluateLand');
                    if (!force_restart)
                        $state.go('land-valuation.step3', { langcode: storedLang, calculate: true, top: window.topKey });
                    else
                        $window.location.href = $state.href('land-valuation.step3', { langcode: storedLang, calculate: true, top: window.topKey });
                }
                else if (window.localStorage.getItem('ivaluateField')) {
                    window.localStorage.removeItem('ivaluateField');
                    if (!force_restart)
                        $state.go('field-valuation.step4', { langcode: storedLang, calculate: true, top: window.topKey });
                    else
                        $window.location.href = $state.href('field-valuation.step4', { langcode: storedLang, calculate: true, top: window.topKey });
                }
                else if (window.localStorage.getItem('ivaluateCommercial')) {
                    window.localStorage.removeItem('ivaluateCommercial');
                    if (!force_restart)
                        $state.go('commercial-valuation.step4', { langcode: storedLang, calculate: true, top: window.topKey });
                    else
                        $window.location.href = $state.href('commercial-valuation.step4', { langcode: storedLang, calculate: true, top: window.topKey });
                }
                else if (res.lastState === "field-valuation.step4") {
                    if (!force_restart)
                        $state.go('field-valuation.step4', { langcode: storedLang, calculate: true, top: window.topKey });
                    else
                        $window.location.href = $state.href('field-valuation.step4', { langcode: storedLang, calculate: true, top: window.topKey });
                }
                else if (res.lastState === "land-valuation.step4") {
                    if (!force_restart)
                        $state.go('land-valuation.step3', { langcode: storedLang, calculate: true, top: window.topKey });
                    else
                        $window.location.href = $state.href('land-valuation.step3', { langcode: storedLang, calculate: true, top: window.topKey });
                }
                else if (res.lastState === "resident-valuation.step4") {
                    if (!force_restart)
                        $state.go('resident-valuation.step4', { langcode: storedLang, calculate: true, top: window.topKey });
                    else
                        $window.location.href = $state.href('resident-valuation.step4', { langcode: storedLang, calculate: true, top: window.topKey });
                }
                else if (res.lastState === "commercial-valuation.step4") {
                    if (!force_restart)
                        $state.go('commercial-valuation.step4', { langcode: storedLang, calculate: true, top: window.topKey });
                    else
                        $window.location.href = $state.href('land-commercial.step5', { langcode: storedLang, calculate: true, top: window.topKey });
                }
                else if (res.lastState === "confirmEmail" ||
                    res.lastState === "register" ||
                    res.lastState === "404" ||
                    res.lastState === "signin" ||
                    res.lastState === "default" ||
                    res.lastState === "forgotPassword" ||
                    res.lastState === "newPassword" ||
                    res.lastState === "resetPassword" ||
                    res.lastState === "confirmuser" ||
                    res.lastState === "activateEmail" ||
                    res.lastState === "unblock" ||
                    res.lastState === "sso") {
                    if (!force_restart)
                        $state.go('default', { langcode: storedLang, force: 'redirect' });
                    else
                        $window.location.href = $state.href('default', { langcode: storedLang, force: 'redirect' });
                }
                else {
                    var hrefer = $state.href(res.lastState, res.lastParams);
                    if (hrefer) {
                        if (!force_restart)
                            $state.go(res.lastState, res.lastParams);
                        else
                            $window.location.href = $state.href(res.lastState, res.lastParams);
                    } else {
                        if (!force_restart)
                            $state.go('default', { langcode: storedLang, force: 'redirect' });
                        else
                            $window.location.href = $state.href('default', { langcode: storedLang, force: 'redirect' });
                    }
                }
                // service.removeLastState();
            });
        }

        function saveLastState(state, params) {
            if (state === "confirmEmail" ||
                state === "register" ||
                state === "default" ||
                state === "signin" ||
                state === "forgotPassword" ||
                state === "newPassword" ||
                state === "resetPassword" ||
                state === "code" ||
                state === "confirmuser" ||
                state === "activateEmail") {
                //do nothing
            }
            else {
                localStorageService.set('fromState', state);
                localStorageService.set('fromParams', params);
            }
        }

        function removeLastState() {
            localStorageService.remove('fromState');
            localStorageService.remove('fromParams');
        }

    }

})();
